import {useEffect, useState} from 'react';
import LogbookApi from "src/api/staffApi/logbookApi";
import floatParser from "src/helpers/floatParser";

export interface IGunlukVeri {
    satis: number;
    gider: number;
    mas15: number;
    mas30: number;
    mas90: number;
    mag15: number;
    mag30: number;
    mag90: number;
}

export const useMaliRaporlar = () => {
    const [gunlukVeri, setGunlukVeri] = useState<Record<string, IGunlukVeri>>({});
    const [aylikVeri, setAylikVeri] = useState<Record<string, any>>({});
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        LogbookApi.getHesapRaporlari()
            .then((res: any) => {
                const tempGunlukVeri: Record<string, IGunlukVeri> = {};
                const aylikKayitlar: Record<string, any> = {};

                const satislar = res.satislar || [];
                const gunlukGiderlerRaw = res.gunluk_giderler || [];
                
                // Giderleri tarihe göre mapleyelim
                const giderMap: Record<string, number> = {};
                gunlukGiderlerRaw.forEach((g: any) => {
                    giderMap[g.tarih] = floatParser(g.toplam_tutar);
                });

                // Tüm günlerin (satış olan günlerin) gider listesini oluşturalım
                const fullGiderList = satislar.map((s: any) => ({
                    tarih: s.tarih,
                    toplam_tutar: giderMap[s.tarih] || 0
                }));

                // SATIŞLAR VE ORTALAMALAR
                satislar.forEach((satis: any, i: number) => {
                    const getAvg = (days: number) => {
                        let sum = 0;
                        let count = 0;
                        for (let j = Math.max(0, i - days + 1); j <= i; j++) {
                            const val = floatParser(satislar[j].toplam_tutar);
                            sum += val;
                            count++;
                        }
                        return count > 0 ? sum / count : 0;
                    };

                    const getAvgGider = (days: number) => {
                        let sum = 0;
                        let count = 0;
                        for (let j = Math.max(0, i - days + 1); j <= i; j++) {
                            sum += fullGiderList[j].toplam_tutar;
                            count++;
                        }
                        return count > 0 ? sum / count : 0;
                    };

                    const currentGider = giderMap[satis.tarih] || 0;

                    tempGunlukVeri[satis.tarih] = {
                        satis: floatParser(satis.toplam_tutar),
                        gider: currentGider,
                        mas15: getAvg(15),
                        mas30: getAvg(30),
                        mas90: getAvg(90),
                        mag15: getAvgGider(15),
                        mag30: getAvgGider(30),
                        mag90: getAvgGider(90),
                    };

                    const donem = satis.tarih?.substring(3, 10);
                    aylikKayitlar[donem] = !aylikKayitlar[donem]
                        ? {
                            toplamSatis: floatParser(satis.toplam_tutar),
                            toplamGider: currentGider,
                            gun: 1,
                            giderTipleri: {},
                        }
                        : {
                            ...aylikKayitlar[donem],
                            toplamSatis: aylikKayitlar[donem].toplamSatis + floatParser(satis.toplam_tutar),
                            toplamGider: aylikKayitlar[donem].toplamGider + currentGider,
                            gun: aylikKayitlar[donem].gun + 1,
                        };
                });

                setGunlukVeri(tempGunlukVeri);
                setAylikVeri(aylikKayitlar);
                setIsLoading(false);
            })
            .catch((e: any) => {
                console.warn(e);
                setIsLoading(false);
            });
    }, []);

    return {gunlukVeri, aylikVeri, isLoading};
};
